import api from './api';

// ── Roles ─────────────────────────────────────────────────────────────────────
export const getRoles      = (category) => api.get('/roles', { params: { category } });
export const getCategories = () => api.get('/roles/categories');
export const getRole       = (slug) => api.get(`/roles/${slug}`);
export const getRoleProgress = (slug) => api.get(`/roles/${slug}/progress`);

// ── Questions ─────────────────────────────────────────────────────────────────
export const getSubChapterQuestions = (subChapterId, retake = false) =>
  api.get(`/questions/sub-chapter/${subChapterId}${retake ? '?retake=true' : ''}`);
export const explainConcept = (questionId) =>
  api.post(`/questions/${questionId}/explain`);

// ── Answers ───────────────────────────────────────────────────────────────────
export const submitMCQ      = (data) => api.post('/answers/mcq', data);
export const submitWritten  = (data) => api.post('/answers/written', data);
export const submitSpoken   = (data) => api.post('/answers/spoken', data);
export const getImprovementPlan = (progressId) =>
  api.post('/answers/improvement-plan', { progress_id: progressId });

// ── Progress ──────────────────────────────────────────────────────────────────
export const startProgress    = (subChapterId, retake = false) =>
  api.post('/progress/start', { sub_chapter_id: subChapterId, retake });
export const completeProgress = (progressId) =>
  api.post('/progress/complete', { progress_id: progressId });
export const getResults       = (progressId) =>
  api.get(`/progress/results/${progressId}`);
export const getDashboardProgress = () => api.get('/progress/dashboard');
export const getStreak            = () => api.get('/progress/streak');

// ── Profile & Settings ────────────────────────────────────────────────────────
export const updateProfile    = (data) => api.put('/auth/profile', data);
export const changePassword   = (data) => api.post('/auth/change-password', data);

// ── Certificates ──────────────────────────────────────────────────────────────
export const getCertificates  = () => api.get('/certificates');

// ── JD Prep ───────────────────────────────────────────────────────────────────
export const getJDPrepSessions   = ()       => api.get('/jd-prep');
export const getJDPrepUsage      = ()       => api.get('/jd-prep/usage');
export const getJDPrepSession    = (id)     => api.get(`/jd-prep/${id}`);
export const generateJDPrep      = (data)   => api.post('/jd-prep/generate', data);
export const deleteJDPrepSession = (id)     => api.delete(`/jd-prep/${id}`);
export const getSavedCV            = ()           => api.get('/jd-prep/cv');
export const evaluateJDPrepAnswers = (id, answers) => api.post(`/jd-prep/${id}/evaluate-answers`, { answers });

// ── Study chapters ────────────────────────────────────────────────────────────
export const getStudyContent      = (subChapterId)          => api.get(`/study/${subChapterId}`);
export const markStudyComplete    = (subChapterId)          => api.post(`/study/${subChapterId}/complete`);
export const submitGateAnswers    = (subChapterId, answers) => api.post(`/study/${subChapterId}/gate`, { answers });

// ── Engagement ────────────────────────────────────────────────────────────────
export const getWeakSpots         = (roleId)                 => api.get(`/progress/weak-spots/${roleId}`);
export const getWeakQuestions     = (roleId)                 => api.get(`/progress/weak-questions/${roleId}`);
export const getPercentile        = (subChapterId)           => api.get(`/progress/percentile/${subChapterId}`);
export const getDailyChallenge    = ()                       => api.get('/progress/daily-challenge');
export const completeDailyChallenge = (question_id, selected_index) =>
  api.post('/progress/daily-challenge/complete', { question_id, selected_index });
export const getMilestones        = (roleId)                 => api.get(`/progress/milestones/${roleId}`);
export const checkMilestones      = (role_id)                => api.post('/progress/milestones/check', { role_id });
export const getFeatureFlags      = ()                       => api.get('/system/features');

// ── Courses ────────────────────────────────────────────────────────────────────
export const getCourses          = (type)     => api.get('/courses', { params: type ? { type } : {} });
export const getCourse           = (slug)     => api.get(`/courses/${slug}`);
export const getCourseTopic      = (topicId)  => api.get(`/courses/topic/${topicId}`);
export const getMyEnrollments    = ()         => api.get('/courses/my-enrollments');
export const enrollCourse        = (courseId) => api.post(`/courses/${courseId}/enroll`);
export const getCourseForReader  = (courseId) => api.get(`/courses/learn/${courseId}`);
export const completeChapter     = (chapterId) => api.post(`/courses/chapter/${chapterId}/complete`);
export const updateCourseProgress = (courseId, topicId) => api.patch(`/courses/${courseId}/progress`, { topic_id: topicId });

// ── Subscriptions / Slots ─────────────────────────────────────────────────────
export const getSubscriptionSlots = () => api.get('/subscriptions/slots');
export const activateRole = (roleId) => api.post('/subscriptions/activate-role', { role_id: roleId });

// ── Wallet ────────────────────────────────────────────────────────────────────
export const getWallet          = ()     => api.get('/wallet');
export const getWalletTxns      = ()     => api.get('/wallet/transactions');
export const redeemVoucher      = (code) => api.post('/wallet/redeem', { code });
export const submitWithdrawal   = (data) => api.post('/wallet/withdraw', data);
export const getWithdrawals     = ()     => api.get('/wallet/withdrawals');
export const deleteAccount      = ()     => api.delete('/auth/account');

// ── Interviews & Outcomes ─────────────────────────────────────────────────────
export const getInterviews   = ()       => api.get('/interviews');
export const logInterview    = (data)   => api.post('/interviews', data);
export const deleteInterview = (id)     => api.delete(`/interviews/${id}`);
export const getOutcome      = (roleId) => api.get(`/interviews/outcome/${roleId}`);
export const recordOutcome   = (data)   => api.post('/interviews/outcome', data);

// ── Job Application Tracker ───────────────────────────────────────────────────
export const getJobTracker   = ()        => api.get('/interviews/tracker');
export const addJobApp       = (data)    => api.post('/interviews/tracker', data);
export const updateJobApp    = (id, d)   => api.patch(`/interviews/tracker/${id}`, d);
export const deleteJobApp    = (id)      => api.delete(`/interviews/tracker/${id}`);

// ── Performance Analytics ─────────────────────────────────────────────────────
export const getProgressAnalytics = ()        => api.get('/progress/analytics');
export const getStudyPlan         = (role_id) => api.get('/progress/study-plan', { params: { role_id } });
export const generateStudyPlan    = (data)    => api.post('/progress/study-plan', data);

// ── ATS ───────────────────────────────────────────────────────────────────────
export const getATSUsage    = ()   => api.get('/ats/usage');
export const getATSSessions = ()   => api.get('/ats');
export const getATSSession  = (id) => api.get(`/ats/${id}`);
export const analyzeATS     = (fd) =>
  api.post('/ats/analyze', fd, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 });

// ── Mock Interview ────────────────────────────────────────────────────────────
export const startMockInterview = (data)      => api.post('/mock-interview/start', data);
export const sendMockTurn       = (sid, ans)  => api.post(`/mock-interview/${sid}/turn`, { answer: ans });
export const getMockSession     = (sid)       => api.get(`/mock-interview/${sid}`);
export const getMockQuota       = ()          => api.get('/mock-interview/quota');
export const getMockSessions    = ()          => api.get('/mock-interview/sessions');

// ── Notifications ─────────────────────────────────────────────────────────────
export const getNotifications  = ()   => api.get('/notifications');
export const getNotifCount     = ()   => api.get('/notifications/count');
export const markNotifRead     = (id) => api.patch(`/notifications/${id}/read`);
export const markAllNotifsRead = ()   => api.patch('/notifications/read-all');

// ── Readiness Score ────────────────────────────────────────────────────────────
export const getReadinessScore   = (roleId)           => api.get(`/progress/readiness/${roleId}`);
export const setConfidenceRating = (progressId, rating) => api.patch(`/progress/${progressId}/confidence`, { confidence_rating: rating });

// ── STAR Coach ────────────────────────────────────────────────────────────────
export const getStarQuestions  = ()     => api.get('/star-coach/questions');
export const analyzeStarAnswer = (data) => api.post('/star-coach/analyze', data);
export const getStarHistory    = ()     => api.get('/star-coach/history');
export const deleteStarSession = (id)   => api.delete(`/star-coach/${id}`);

// ── Cover Letter ──────────────────────────────────────────────────────────────
export const getCoverLetterCV      = ()     => api.get('/cover-letter/saved-cv');
export const generateCoverLetter   = (data) => api.post('/cover-letter/generate', data);
export const getCoverLetterHistory = ()     => api.get('/cover-letter/history');
export const deleteCoverLetter     = (id)   => api.delete(`/cover-letter/${id}`);

// ── Company Prep ──────────────────────────────────────────────────────────────
export const scrapeCompanyUrl      = (url)  => api.post('/company-prep/scrape', { url });
export const getCompanyPrepCV      = ()     => api.get('/company-prep/saved-cv');
export const generateCompanyPrep   = (data) => api.post('/company-prep/generate', data);
export const getCompanyPrepHistory = ()     => api.get('/company-prep/history');

// ── Debrief ───────────────────────────────────────────────────────────────────
export const getDebriefInterviews = ()     => api.get('/debrief/interviews');
export const analyzeDebrief       = (data) => api.post('/debrief/analyze', data);
export const getDebriefHistory    = ()     => api.get('/debrief/history');
export const deleteDebrief        = (id)   => api.delete(`/debrief/${id}`);

// ── LinkedIn Optimiser ────────────────────────────────────────────────────────
export const analyzeLinkedIn    = (fd) => api.post('/linkedin-opt/analyze', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
export const getLinkedInHistory = ()   => api.get('/linkedin-opt/history');
export const deleteLinkedIn     = (id) => api.delete(`/linkedin-opt/${id}`);

// ── Salary Negotiation ────────────────────────────────────────────────────────
export const getSalaryNegCV      = ()               => api.get('/salary-neg/saved-cv');
export const generateSalaryNeg   = (data)           => api.post('/salary-neg/generate', data);
export const practiceNegotiation = (id, message)    => api.post(`/salary-neg/${id}/practice`, { message });
export const getSalaryNegHistory = ()               => api.get('/salary-neg/history');
export const getSalaryNegSession = (id)             => api.get(`/salary-neg/${id}`);
export const deleteSalaryNeg     = (id)             => api.delete(`/salary-neg/${id}`);

// ── Readiness Report ──────────────────────────────────────────────────────────
export const getMyReport           = ()     => api.get('/readiness-report/my');
export const updateMyReport        = (data) => api.patch('/readiness-report/my', data);
export const generateReportSummary = ()     => api.post('/readiness-report/my/ai-summary');
export const deleteReportSummary   = ()     => api.delete('/readiness-report/my/ai-summary');
export const getPublicReport       = (token) => api.get(`/readiness-report/public/${token}`);
